import React, { Component } from 'react';
import {
	HeaderView,
	FooterView,
	SamplesView,
} from './components/views';

class SamplesPage extends Component {
	componentDidMount () {
		window.scrollTo(0, 0);
	}

	render () {
		return (
			<main>
				<HeaderView opaque={true} />
				<SamplesView />
				<FooterView />
			</main>
		);
	}
}

export default SamplesPage;



// WEBPACK FOOTER //
// ./src/SamplesPage.js